import { useUserContext } from "@repo/baseCloud";
import { Column, DateColumn, Grid } from "@repo/ui";
import { useMemo } from "react";

import { useRepEnrollmentQuery } from "..";
import { useSettingsQuery } from "../../../../helpers/queryHooks";
import MapSale from "../../../../models/mapSale";

const columns = [
	new Column("Enrollment ID", "enrollmentID"),
	new Column("Utility Account Number", "utilityAccountNumber"),
	new DateColumn("Date Of Sale", "timestamp"),
	new Column("Customer Name", "customer"),
	new Column("Service Addresses", "serviceAddresses"),
	new Column("Meter Count", "meterCount"),
	new Column("Machine Name", "machine"),
] as Column<MapSale>[];

const vendorColumns = [
	new Column("Enrollment ID", "enrollmentID"),
	new DateColumn("Date Of Sale", "timestamp"),
	new Column("Meter Count", "meterCount"),
	new Column("Machine Name", "machine"),
] as Column<MapSale>[];

export function RecentEnrollmentsGrid() {
	const { data, loaded, clearQuery } = useRepEnrollmentQuery();
	const { user } = useUserContext();
	const [settings] = useSettingsQuery();
	const hidePII = settings.hidePIIForVendors && !user?.userIsAdmin;

	const actualColumns = useMemo(() => (hidePII ? vendorColumns : columns), [hidePII]);

	return (
		<Grid
			id="recentEnrollmentsGrid"
			columns={actualColumns}
			keyProperty="enrollmentID"
			values={data?.enrollments ?? []}
			loading={!loaded}
			getData={clearQuery}
		/>
	);
}
